import getAgent, { AgentInfo } from '@egjs/agent';
import { useRef } from 'react';

export default function useUserAgent() {
  const agent = useRef<AgentInfo>();

  const getSavedAgent = () => {
    if (!agent.current) {
      agent.current = getAgent();
    }
    return agent.current;
  };

  return getSavedAgent();
}
